import { login, logout, getInfo } from '@/api/user'
import { phoneLogin } from '@/api/h5'
// 获取token|设置token|删除token的函数
import { getToken, setToken, removeToken } from '@/utils/auth'
// 路由模块当中重置路由的方法
// import router, { anyRoutes, resetRouter, asyncRoutes, constantRoutes } from '@/router'
import router, { anyRoutes, resetRouter, constantRoutes } from '@/router'
// import router from '@/router'
// 箭头函数
// import router from '@/router';
const getDefaultState = () => {
  return {
    // 获取token
    token: getToken(),
    // 存储用户名
    loginName: '',
    // 存储用户头像
    avatar: '',
    // 服务器返回的菜单信息【根据不同的角色：返回的标记信息，数组里面的元素是字符串】
    routes: [],
    // 角色信息
    roles: [],
    // 按钮权限的信息
    buttons: [],
    // 对比之后【项目中已有的异步路由，与服务器返回的标记信息进行对比最终需要展示的理由】
    resultAsyncRoutes: [],
    // 用户最终需要展示全部路由
    resultAllRputes: [],
    // 用户时区保存
    saveTimeZone: '',
    userinfo: {}
  }
}
const state = getDefaultState()
// 唯一修改state的地方
const mutations = {
  // 保存时区
  updateAlltime(state, timezone) {
    state.saveTimeZone = timezone
    localStorage.setItem('timezone', JSON.stringify(timezone))
  },
  // 重置state
  RESET_STATE: state => {
    Object.assign(state, getDefaultState())
  },
  // 存储token
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  // 存储用户信息
  SET_USERINFO: (state, userinfo) => {
    // 用登录名
    // state.loginName = userinfo.loginName
    // localStorage.setItem('usernamelocal', JSON.stringify(userinfo.loginName))
    // 用户全名
    // state.fullName = userinfo.fullName
    // 用户电话
    // state.phoneNo = userinfo.phoneNo
    // 用户ID
    // state.userId = userinfo.userId
    state.userinfo = userinfo
  },
  // 最终计算出的异步路由
  SET_RESULTASYNCROUTES: (state, asyncRoutes) => {
    // vuex保存当前用户的异步路由，注意，一个用户需要展示完成路由：常量、异步、任意路由
    state.resultAsyncRoutes = asyncRoutes
    // 计算出当前用户需要展示所有路由
    state.resultAllRputes = constantRoutes.concat(state.resultAsyncRoutes, anyRoutes)
    // 给路由器添加新的路由
    router.addRoutes(state.resultAllRputes)
  }
}

// const computedAsyncRoutes = (asyncRoutes, routes) => {
//   return asyncRoutes.filter(item => {
//     // 数组当中没有这个元素返回索引值-1，如果有这个元素返回的索引值一定不是-1
//     if (routes.indexOf(item.name) !== -1) {
//       if (item.children && item.children.length) {
//         item.children = computedAsyncRoutes(item.children, routes)
//       }
//       return true
//     }
//   })
// }
// actions
const actions = {
  // 这里在处理登录业务
  async login({ commit }, userInfo) {
    // 解构出用户名与密码
    const { account, key, code, pwd } = userInfo
    const res = await login({
      account: account,
      pwd: pwd,
      key: key,
      code: code
    })
    // 注意：当前登录请求现在使用mock数据，mock数据code是20000
    if (res.code === 200) {
      // console.log('===res1111', res)
      // vuex存储token
      commit('SET_TOKEN', res.data.token)
      // commit('SET_USERINFO', res.data.userinfo)
      // 本地持久化存储token
      setToken(res.data.token)
      // console.log('===res222', res)
      return 'ok'
    } else {
      return Promise.reject(new Error('faile'))
    }
  },
  async phoneLogin({ commit }, userInfo) {
    // 解构出用户名与密码
    const { account, pwd } = userInfo
    const res = await phoneLogin({
      loginName: account,
      loginPwd: pwd,
      timeout: 50000
    })
    // 注意：当前登录请求现在使用mock数据，mock数据code是20000
    if (res.code === 200) {
      console.log('===res1111', res)
      // vuex存储token
      commit('SET_TOKEN', res.data.token)
      // commit('SET_USERINFO', res.data.userinfo)
      // 本地持久化存储token
      setToken(res.data.token)
      // console.log('===res222', res)
      return 'ok'
    } else {
      return Promise.reject(new Error('faile'))
    }
  },
  // 获取用户信息
  async getInfo({ commit }) {
    // console.log('===res333', '333333')
    const res = await getInfo()
    if (res.code === 200) {
      // console.log('===res444', res)
      commit('SET_USERINFO', res.data)
      // localStorage.setItem('tenantType', res.data.tenantType)
      // commit('SET_RESULTASYNCROUTES', computedAsyncRoutes(asyncRoutes, res.data.routes))
      return 'ok'
    } else {
      return Promise.reject(new Error('faile'))
    }
  },
  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      logout()
        .then(() => {
          removeToken()
          resetRouter()
          // commit('RESET_STATE')
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      removeToken()
      commit('RESET_STATE')
      resolve()
    })
  }
}

export default {
  state,
  mutations,
  actions
}
